<script lang="ts">
  import type { StyleValue } from 'vue'
  import { defineComponent, computed } from 'vue'
  import { getNamespace } from '../../../utils/global-config'
  import { addUnit } from '../../../shared/utils'

  export default defineComponent({
    name: 'BnIconAppLove',
    props: {
      size: {
        type: [Number, String],
        default: undefined
      },
      rotate: {
        type: Number,
        default: undefined
      },
      spin: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: undefined
      }
    },
    setup(props) {
      const ns = getNamespace('icon')

      const styles = computed(() => {
        const styles: StyleValue = {}
        if (props.size) {
          styles.fontSize = addUnit(props.size)
        }

        if (props.rotate) {
          styles.transform = `rotate(${props.rotate}deg)`
        }

        if (props.color) {
          styles.color = props.color
        }
        return styles
      })

      const cls = computed(() => [
        ns,
        {
          [`${ns}-loading`]: props.spin
        }
      ])

      return {
        cls,
        styles
      }
    }
  })
</script>

<template>
  <i :class="cls" :style="styles">
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>编组 16</title>
      <g id="抓潜拓客" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          id="菜单图标"
          transform="translate(-200.000000, -630.000000)"
          fill="#9CA6B9"
          fill-rule="nonzero"
        >
          <g id="编组-16" transform="translate(200.000000, 630.000000)">
            <path
              id="路径"
              d="M15.5423645,4.20631117 C14.4193819,4.26505161 13.3601267,4.73153417 12.5199947,5.50941257 L12.501,5.527 L12.4866227,5.51242253 C11.5890125,4.67814667 10.4309311,4.2 9.21607754,4.2 C6.43150296,4.2 4.2,6.65148393 4.2,9.62944785 C4.2,11.0739249 4.5956587,12.0172407 5.54825697,13.5121285 C6.23608648,14.5987626 7.35417717,15.8264023 8.75516223,17.1265505 L9.2735322,17.5993743 L9.84146642,18.1000461 L10.383264,18.5630765 L11.0149184,19.0846799 L11.2725374,19.290082 L11.4799028,19.4500443 C11.7644024,19.6759373 12.1264647,19.8 12.5,19.8 C12.8735353,19.8 13.2355976,19.6759373 13.5358046,19.4379043 L13.7317409,19.2864551 L14.1253965,18.9692236 L14.6100882,18.5655479 L15.1535678,18.0997561 L15.7235872,17.5961762 L15.9139176,17.4241237 C17.4661347,16.0120145 18.7060734,14.6797727 19.4513231,13.5127868 C20.4043413,12.0172407 20.8,11.0739249 20.8,9.62944785 C20.8,6.65148393 18.568497,4.2 15.7839225,4.2 L15.5423645,4.20631117 Z M15.7839225,5.8 C17.6495237,5.8 19.2,7.5033218 19.2,9.62944785 C19.2,10.6883423 18.9035913,11.3950296 18.1024189,12.6522887 C17.4516123,13.6713856 16.2931284,14.916109 14.8372226,16.2406002 L14.2877363,16.7315229 L13.5842961,17.337544 L12.9826523,17.8364826 L12.6431209,18.1065474 L12.5574398,18.1720416 C12.5266184,18.1961655 12.5154279,18.2 12.5,18.2 C12.4845721,18.2 12.4733816,18.1961655 12.4582675,18.1841816 L12.1162589,17.9170286 L11.4903936,17.4034088 L11.1278087,17.0963313 L10.5507937,16.5943758 L10.1590247,16.243325 C8.70252218,14.9207429 7.54573914,13.676237 6.89887779,12.6543304 C6.09640868,11.3950296 5.8,10.6883423 5.8,9.62944785 C5.8,7.5033218 7.35047626,5.8 9.21607754,5.8 C10.2339051,5.8 11.2073121,6.31581466 11.854719,7.1992571 L12.4965186,8.07504794 L13.1428311,7.20258219 C13.8013445,6.31364625 14.7688131,5.8 15.7839225,5.8 Z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </i>
</template>
